import {
  CardPaymentsRetryPolicy,
  RetryCombineMode,
  RetryRule,
  Weekday,
} from "../../../../apis/requests/payment-flows/types";

export const WEEKDAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"] as const satisfies readonly Weekday[];
export const RETRY_RULES = ["day_1", "skip_weekdays", "peak_day", "schedule"] as const satisfies readonly RetryRule[];
export const COMBINE_MODES = ["union", "first_match"] as const satisfies readonly RetryCombineMode[];
export const HOURS: readonly number[] = Array.from({length: 24}, (_, hour) => hour);
export const LAST_DAY_OF_MONTH = "last";
export const DAYS_OF_MONTH: readonly number[] = Array.from({length: 31}, (_, index) => index + 1);
export const PERMITTED_HOURS_HELP = "Schedule, weekday and peak hours can only use these.";

export const COMBINE_MODE_OPTIONS: {value: RetryCombineMode; label: string}[] = [
  {value: "union", label: "Combine all"},
  {value: "first_match", label: "First match wins"},
];

export const COMBINE_MODE_SUMMARY: Record<RetryCombineMode, string> = {
  union: "combine all",
  first_match: "first match wins",
};

export const RETRY_RULE_LABELS: Record<RetryRule, string> = {
  day_1: "Day 1",
  skip_weekdays: "Skip weekdays",
  peak_day: "Peak day",
  schedule: "Schedule",
};

export const EMPTY_POLICY: CardPaymentsRetryPolicy = {
  max_day: 14,
  combine: "union",
  order: [],
  permitted_hours: [],
  schedule: {},
  weekday_hours: {},
  skip_weekdays: [],
  peak_day: [],
  peak_day_hours: [],
  peak_min_day: 1,
};
